import { render, staticRenderFns } from "./UserRolesDialog.vue?vue&type=template&id=5608b7fb&scoped=true&"
import script from "./UserRolesDialog.vue?vue&type=script&lang=js&"
export * from "./UserRolesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608b7fb",
  null
  
)

export default component.exports